export class GRPCEnvironment {
  domain!: string;
  mainApidomain!: string;
  cookieUserTokenName!: string;
}
